import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-[#FAF8FF] py-16 md:py-24 px-4 md:px-6" data-id="element-140">
      <div className="max-w-3xl mx-auto text-center" data-id="element-141">
        <FadeIn data-id="element-142">
          <div className="inline-flex justify-center items-center w-16 h-16 md:w-20 md:h-20 bg-purple-100 rounded-full mb-6 md:mb-8" data-id="element-143">
            <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-purple-600" data-id="element-144" />
          </div>

          <h2 className="text-2xl md:text-4xl font-serif text-night-900 mb-6 md:mb-8" data-id="element-145">
            Garantía total de 7 días — Sin preguntas, sin complicaciones.
          </h2>
        </FadeIn>

        <div className="space-y-4 md:space-y-6 text-base md:text-lg text-slate-700 leading-relaxed" data-id="element-146">
          <FadeIn delay={0.1} data-id="element-147">
            <p data-id="element-148">
              Sé que tomar una decisión de compra online requiere confianza.
            </p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-149">
            <p data-id="element-150">Por eso te doy 7 días completos para aplicar el método.</p>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-151">
            <p data-id="element-152">
              Si al cabo de una semana sientes que no valió la pena, me escribes
              y te devuelvo el 100% de tu dinero. Sin formularios complicados.
              Sin explicaciones. Sin drama.
            </p>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-153">
            <p className="font-medium text-night-900 text-lg md:text-xl mt-6 md:mt-8" data-id="element-154">
              El riesgo es completamente mío. Lo único que puedes perder es otra
              semana de mal sueño.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}